import axios from 'axios';
import { ErrorApi, GeneralErrorMessage } from './ErrorApi';

// axios.interceptors.request.use((request) => {
//   Object.assign(request.headers, {
//     Authorization: 'Bearer ' + AuthService.apiToken,
//     Pragma: 'no-cache',
//   });
//   return request;
// });

axios.interceptors.response.use(
  (response) => response,
  (error: any) => {

    if (error.response) {
      switch (error.response.status) {
        case 401: {
          return Promise.reject(<ErrorApi> { code: error.code , message: error.message });
        }
        default: {
          return Promise.reject(<ErrorApi> { code: error.code , message: error.message });
        }
      }
    } else {
      if ( error.message === 'Network Error') {
        location.reload();
        return new Promise(() => setTimeout(error.message, 15000));  // setTimeout to avoid displaying the toaster before reload page
      }
      return Promise.reject(<ErrorApi> { code: 0 , message: error });
    }
  },
);

// function acquireToken(error: any) {
//   const originalRequest = error.config;
//   if (!originalRequest._retry) {
//     originalRequest._retry = true;
//     return AuthService.acquireToken()
//       .then(() => {
//         return axios.request(originalRequest);
//       })
//       .catch(() => {
//         AuthService.signOut();
//         return;
//       });
//   }
// }

export default axios;
